import { formatInTimeZone } from 'date-fns-tz';

export type ResolvedGlucoseTimezone = {
  timezone: string;
  usedUtcFallback: boolean;
};

export function resolveGlucoseTimezone(
  patientTimezone: string | null | undefined,
): ResolvedGlucoseTimezone {
  if (patientTimezone) {
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: patientTimezone }).format();
      return { timezone: patientTimezone, usedUtcFallback: false };
    } catch {
      // Invalid Healthie zones deliberately fall through to the visible UTC fallback.
    }
  }

  return { timezone: 'UTC', usedUtcFallback: true };
}

export function formatGlucoseTimestamp(
  observedAt: string,
  timezone: string,
): string {
  return formatInTimeZone(observedAt, timezone, 'MMM d, yyyy, h:mm a zzz');
}
